import React, { useState, useEffect } from 'react';
import './InstallPWA.css';

const InstallPWA = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallPrompt, setShowInstallPrompt] = useState(false);
    const [isInstalled, setIsInstalled] = useState(false);

    useEffect(() => {
        // Check if already installed
        if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
            setIsInstalled(true);
            console.log('✅ App already installed');
            return;
        }

        // Listen for the beforeinstallprompt event
        const handleBeforeInstallPrompt = (e) => {
            console.log('🎯 beforeinstallprompt event fired');
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later
            setDeferredPrompt(e);
            // Show install button after a delay
            setTimeout(() => {
                setShowInstallPrompt(true);
                console.log('📢 Showing install prompt');
            }, 3000); // Show after 3 seconds
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        // Listen for app installed event
        window.addEventListener('appinstalled', () => {
            setIsInstalled(true);
            setShowInstallPrompt(false);
            console.log('✅ PWA installed successfully');
        });

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) {
            console.log('❌ No install prompt available');
            return;
        }

        console.log('📲 Showing install prompt...');
        // Show the install prompt
        deferredPrompt.prompt();

        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;

        if (outcome === 'accepted') {
            console.log('✅ User accepted the install prompt');
        } else {
            console.log('❌ User dismissed the install prompt');
        }

        // Clear the deferredPrompt
        setDeferredPrompt(null);
        setShowInstallPrompt(false);
    };

    const handleDismiss = () => {
        console.log('⏭️ User dismissed install prompt');
        setShowInstallPrompt(false);
        // Don't show again for 7 days
        localStorage.setItem('pwa-install-dismissed', Date.now().toString());
    };

    // Check if user dismissed recently
    useEffect(() => {
        const dismissed = localStorage.getItem('pwa-install-dismissed');
        if (dismissed) {
            const dismissedTime = parseInt(dismissed);
            const sevenDays = 7 * 24 * 60 * 60 * 1000;
            console.log('📅 PWA dismissed time:', new Date(dismissedTime).toLocaleString());
            if (Date.now() - dismissedTime < sevenDays) {
                console.log('⏸️ PWA prompt hidden because it was dismissed recently');
                setShowInstallPrompt(false);
            }
        }
    }, []);

    if (isInstalled || !showInstallPrompt) {
        return null;
    }

    return (
        <div className="install-pwa-banner">
            <div className="install-pwa-content">
                <div className="install-pwa-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 16V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 12L8 8M12 12L16 8M12 12V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="install-pwa-text">
                    <h4>Cài đặt ứng dụng Admin</h4>
                    <p>Cài đặt BBHD Admin để quản lý giải đấu nhanh hơn!</p>
                </div>
                <div className="install-pwa-actions">
                    <button className="install-btn install-btn-primary" onClick={handleInstallClick}>
                        Cài đặt
                    </button>
                    <button className="install-btn install-btn-dismiss" onClick={handleDismiss}>
                        ✕
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InstallPWA;
